var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeleteIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    rx: 6,
    fill: "#FFF5F8"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.8366 20.522L9.66659 12.3333H20.3333L19.1633 20.522C19.1178 20.8397 18.9593 21.1304 18.7169 21.3407C18.4744 21.5509 18.1642 21.6667 17.8433 21.6667H12.1566C11.8356 21.6667 11.5254 21.5509 11.283 21.3407C11.0405 21.1304 10.882 20.8397 10.8366 20.522ZM20.9999 9.66666H17.6666V8.99999C17.6666 8.82318 17.5963 8.65361 17.4713 8.52859C17.3463 8.40357 17.1767 8.33333 16.9999 8.33333H12.9999C12.8231 8.33333 12.6535 8.40357 12.5285 8.52859C12.4035 8.65361 12.3333 8.82318 12.3333 8.99999V9.66666H8.99992C8.82311 9.66666 8.65354 9.7369 8.52851 9.86192C8.40349 9.98695 8.33325 10.1565 8.33325 10.3333C8.33325 10.5101 8.40349 10.6797 8.52851 10.8047C8.65354 10.9298 8.82311 11 8.99992 11H20.9999C21.1767 11 21.3463 10.9298 21.4713 10.8047C21.5963 10.6797 21.6666 10.5101 21.6666 10.3333C21.6666 10.1565 21.5963 9.98695 21.4713 9.86192C21.3463 9.7369 21.1767 9.66666 20.9999 9.66666Z",
    fill: "#F1416C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteIcon);
export default __webpack_public_path__ + "static/media/deleteIcon.dc0d9fc6b8935eff2c976b5777d26390.svg";
export { ForwardRef as ReactComponent };